var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVect2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 1.36427C18.125 1.09433 17.9027 0.875488 17.6285 0.875488H0.746528C0.472305 0.875488 0.25 1.09433 0.25 1.36427V2.42571C0.25 2.68498 0.354623 2.93362 0.540861 3.11697L7.20139 9.67365V19.6361C7.20139 19.9994 7.58982 20.2357 7.91996 20.0733L10.6247 18.742C10.9611 18.5764 11.1736 18.2379 11.1736 17.8676V9.67365L17.8341 3.11697C18.0204 2.93362 18.125 2.68498 18.125 2.42571V1.36427Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVect2);
export default __webpack_public_path__ + "static/media/vect2.db41d5581ffad070467e546d73e3e2f1.svg";
export { ForwardRef as ReactComponent };